import { config } from './config.js';

// Sentry loads lazily so that builds without a DSN don't pull the SDK at all.
// In dev (no DSN) captureError just logs to the console.

let initialized = false;
let sentry = null;

export async function initSentry() {
  if (initialized) return;
  initialized = true;
  if (!config.sentryDsn) return;
  try {
    sentry = await import('@sentry/browser');
    sentry.init({
      dsn: config.sentryDsn,
      release: config.clientVersion,
      environment: location.hostname === 'localhost' ? 'dev' : 'prod',
      tracesSampleRate: 0.1,
      beforeSend(event) {
        if (event.request && event.request.url) {
          event.request.url = event.request.url.replace(/token=[^&]+/g, 'token=REDACTED');
        }
        return event;
      },
    });
  } catch (err) {
    console.warn('Sentry init failed', err);
  }
}

export function captureError(err, ctx = {}) {
  if (sentry) {
    sentry.captureException(err, { extra: ctx });
  } else {
    console.error('[sayermore]', err, ctx);
  }
}

export function setUser(user) {
  if (!sentry) return;
  sentry.setUser(user ? { id: user.id, email: user.primaryEmailAddress?.emailAddress } : null);
}
